/**
 * External dependencies
 */
import React from "react";
import { Box, Heading } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */

const ReportHeader = ({ name, actions }) => {
  return (
    <Box justifyContent="spaceBetween" className="dashboard-report__header">
      <Heading level="4">{name}</Heading>
    </Box>
  );
};

export default ReportHeader;
